import { createApp } from 'vue'
import App from './App.vue'
import TopicEntry from './views/TopicEntry.vue' 
import router from './router'
import 'es6-promise/auto'
import store from '@/store'
import VueLazyLoad from 'vue3-lazyload'
import './assets/detailForm.less'
import VueNumerals from 'vue-numerals';
import LP from './plugins/textProvider.js';
let app1 = createApp(App)
app1.use(router)
    .use(VueLazyLoad)
    .use(store)
    .use(LP)
    .use(VueNumerals, {
        locale: 'en'
    })
    .mount('#app')

let app2 = createApp(TopicEntry)
app2.use(router)
    .use(VueLazyLoad)
    .use(store)
    .use(LP)
    .use(VueNumerals, {
        locale: 'en'
    }).mount('#topicEntry')
 